import { render, staticRenderFns } from "./StockAuxiStock.vue?vue&type=template&id=229654fe"
import script from "./StockAuxiStock.vue?vue&type=script&lang=js"
export * from "./StockAuxiStock.vue?vue&type=script&lang=js"
import style0 from "./StockAuxiStock.vue?vue&type=style&index=0&id=229654fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports